module.exports = __webpack_public_path__ + "static/media/point+3.eb225bc2.png";